<vectronic-card
  [title]="'Confirmation'"
  [displayClose]="true"
  (closed)="onClose()"
  (resized)="onResized($event)"
  [showResize]="true"
>
  <ng-container body>
    <div class="remote-command-confirmation" [ngClass]="{ fullscreen: isFullScreen() }">
      <div class="remote-command-confirmation__hints">
        <p>Please review your entries carefully before transmitting.</p>
        @if (data?.isRemote) {
          <div class="remote-command-confirmation__text-hint">
            <p>Sending this remote command will impact active devices!</p>
          </div>
        }
        @if (shouldShowAirtimeWarning()) {
          <vectronic-alert type="warning">
            <strong>Warning:</strong> Transmitting a fix rate of ≤ 1h with a 3kByte or Economy plan
            may cause increased airtime charges due to higher data volume.
          </vectronic-alert>
        }
        @if (shouldShowUserVisibilityWarning()) {
          <vectronic-alert type="warning">
            <strong>Warning:</strong> Unselected user visibility options will be deactivated.
          </vectronic-alert>
        }
        <div class="remote-command-confirmation__collarIds">
          Device IDs: {{ joinedSelectedCollarIds }}
        </div>
      </div>
      @if (data.parameterDataList?.length) {
        <vectronic-parameter-view
          [parameters]="data.parameters"
          [categories]="data.categories"
          [subsystems]="data.subsystems"
          [shouldInitiallyExpanded]="true"
        ></vectronic-parameter-view>
      }
      @if (
        data.schedules?.length ||
        data.virtualFenceConstructionRules?.length ||
        data.virtualFenceCleared
      ) {
        <rc-schedule-view
          [selectedCollarIds]="data.selectedCollarIds"
          [readonly]="true"
          [showSubmit]="false"
          [showClear]="false"
          [videoFormatsOptions]="data.videoFormatsOptions"
          [photoFormatsOptions]="data.photoFormatsOptions"
          [defaultVirtualFenceConstructionRules]="data.virtualFenceConstructionRules"
          [virtualFenceCleared]="data.virtualFenceCleared"
          [isAdmin]="data.isAdmin"
          [permanentEndDate]="permanentEndDate$ | async"
          [showOverrideWarning]="true"
          [initialScheduleTypes]="data.initialScheduleTypes"
          [initialHasVirtualFence]="data.initialHasVirtualFence"
          [(showPreview)]="showPreview"
        >
        </rc-schedule-view>
      }
    </div>
  </ng-container>
  <ng-container footer>
    <div class="remote-command-confirmation__action-button">
      <button mat-button (click)="onCancel()">
        <mat-icon color="warn">cancel</mat-icon>
        Cancel
      </button>
      <button mat-button (click)="onConfirm()" [attr.data-testid]="'confirm-remote-command'">
        <mat-icon color="accent">check_circle</mat-icon>
        Confirm
      </button>
    </div>
  </ng-container>
</vectronic-card>
